<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
          <n-datepicker title="Дата заполнения" v-bind="$form.input('publishedAt')" />
        </n-items>
      </n-card>

      <block-works :project-id="project.id" class="items" @change="(v) => $form.set('supply', v, 'other')" />
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-input title="Краткое описание строительно-монтажных работ, их месторасположение" v-bind="$form.input('description')" />
        <n-input title="Состояние погоды и температура наружного воздуха" v-bind="$form.input('weather')" />
        <n-input title="Принимаемые меры в особых условиях (зимний период, жара и т.д.)" v-bind="$form.input('solution')" />
        <n-select title="Чертежи" :data="figures" v-bind="$form.input('figures', 'select', 'other')"
                  option-title="file.name" selected-title="file.name" />
        <div style="width: 100%"><n-upload title="Фото/видео файлы" v-bind="$form.input('files', 'input', 'other')" multi /></div>
        <div style="width: 100%"><n-upload title="Исполнительные схемы" v-bind="$form.input('schemas', 'input', 'other')" multi /></div>
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="submit">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
import BlockWorks from './WorksBlock'

export default {
  name: 'PageRecordCreate',
  components: { BlockWorks, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
    }
  },
  created() {
    this.load()
    this.$form.init({
      publishedAt: $app.date.now(),
    })
    this.$form.init({
      figures: [],
    }, true, 'other')
  },
  methods: {
    load() {
      this.$var('load', true)
      const promises = [
        $api.iq.documents.getByProject(this.project.id).filter({ type: 'search:psd-figure', }).tree(),
      ]
      Promise.all(promises).then((response) => {
        this.figures = response[0].data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    submit() {
      this.$var('load', true)
      const api = []
      $n.each(this.$form.get('files', 'other'), (file) => api.push({ promise: $api.files.create({ file, }), type: 'files', }))
      $n.each(this.$form.get('schemas', 'other'), (file) => api.push({ promise: $api.files.create({ file, }), type: 'schemas', }))
      $n.each(this.$form.get('input', 'other'), (file) => api.push({ promise: $api.files.create({ file, }), type: 'input-34', }))

      if (api.length) {
        $n.promiseObjects(api).then((result) => {
          const files = { files: [], schemas: [], 'input-34': [], }
          $n.each(result, (file) => {
            files[file.type].push(file.response.data.content.id)
          })
          this.save(files)
        }).catch((e) => {
          this.$var('load', false)
        })
      } else {
        this.save()
      }
    },
    save(files = {}) {
      const data = {
        record: this.$form.get(),
        ...files,
        supply: this.$form.get('supply', 'other'),
        figures: $n.map(this.$form.get('figures', 'other'), (i) => i.id),
      }
      $api.journals.records.create(this.project.id, this.journal.name, data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
